import { define } from "../preactement/define";
import { Choice } from "../../ChoiceList/Choice";
import { parseBooleanAttr } from "../wrapperUtils";
import { formAttrs } from "../shared-attributes/form";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['checked-children', 'class-name', 'checked', 'default-checked', 'disabled', 'input-class-name', 'inversed', 'name', 'root-id', 'size', 'type', 'unchecked-children', 'value', ...formAttrs];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    checked,
    defaultChecked,
    rootId,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Choice, {
    ...otherProps,
    checked: checked && Boolean(JSON.parse(checked)),
    defaultChecked: defaultChecked && Boolean(JSON.parse(defaultChecked)),
    disabled: parseBooleanAttr(otherProps.disabled),
    id: rootId,
    inversed: parseBooleanAttr(otherProps.inversed)
  });
};
define('ds-choice', () => Wrapper, {
  attributes,
  events: ['onChange', 'onBlur']
});